module.exports = __webpack_public_path__ + "b4c3adf809334e5cf760db17efff89d3.fbx";